<template lang="pug">
    article#vestibular
        Banner
        Diferenciais
        Video(:conteudo="pagina.secoes[0].conteudo")
</template>

<script>
import Banner from '@sections/Vestibular/Banner/Banner.vue' 
import Diferenciais from '@sections/Vestibular/Diferenciais/Diferenciais.vue' 
import Video from '@sections/Vestibular/Video/Video.vue' 

import pagina from '@/mixins/pagina'

export default {
    name: "view-vestibular",
    components: {
        Banner, 
        Diferenciais, 
        Video
    },
    mixins: [
        pagina
    ],
}
</script>

<style lang="stylus" scoped src="./Vestibular.styl"></style>